var _path, _circle, _circle2, _circle3, _circle4, _path2, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 95,
    viewBox: "0 0 132 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4202 64.4722C90.6063 58.9136 84.4098 55.9381 78.3124 57.2174L58.0748 61.4635C51.9773 62.7429 47.4993 67.9582 47.1569 74.179C46.602 84.2602 37.9797 91.9829 27.8985 91.428C17.8173 90.8732 10.0946 82.2509 10.6495 72.1697L12.6589 35.6623C13.2137 25.5811 21.836 17.8584 31.9172 18.4133C32.7596 18.4596 33.5856 18.5623 34.3916 18.7175C37.8485 19.383 41.3975 20.1322 44.8428 19.4093L73.525 13.3913C76.9703 12.6684 79.919 10.5559 82.8168 8.55708C83.4925 8.091 84.2076 7.66497 84.9604 7.2839C93.9684 2.72381 104.968 6.32958 109.528 15.3376L126.041 47.9586C130.601 56.9667 126.995 67.9658 117.987 72.5259C108.979 77.086 97.9803 73.4802 93.4202 64.4722Z",
    fill: "#1E48FF",
    fillOpacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0002,
    cy: 36.8934,
    r: 14.6251,
    transform: "rotate(-11.8496 31.0002 36.8934)",
    fill: "#A493F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.0256,
    cy: 23.8796,
    r: 14.6251,
    transform: "rotate(-11.8496 93.0256 23.8796)",
    fill: "#A493F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.6554,
    cy: 56.5081,
    r: 6.96879,
    transform: "rotate(-11.8496 52.6554 56.5081)",
    fill: "#A493F7",
    stroke: "#C0B4F7",
    strokeWidth: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.2823,
    cy: 50.5017,
    r: 6.96879,
    transform: "rotate(-11.8496 81.2823 50.5017)",
    fill: "#A493F7",
    stroke: "#C0B4F7",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.18 26.6276C31.7992 24.8126 30.0192 23.65 28.2043 24.0308C26.3893 24.4116 25.2267 26.1916 25.6075 28.0066L25.9294 29.5408C26.4879 32.2025 24.7829 34.8129 22.1213 35.3714L20.5881 35.693C18.7732 36.0739 17.6106 37.8539 17.9914 39.6688C18.3722 41.4837 20.1522 42.6463 21.9671 42.2655L23.5003 41.9439C26.1619 41.3854 28.7723 43.0904 29.3308 45.752L29.7445 47.724C30.1253 49.5389 31.9053 50.7015 33.7203 50.3207C35.5352 49.9399 36.6978 48.1599 36.317 46.345L35.9188 44.4471C35.3518 41.7445 37.083 39.094 39.7855 38.527L41.6846 38.1285C43.4995 37.7477 44.6621 35.9677 44.2813 34.1528C43.9005 32.3378 42.1205 31.1752 40.3056 31.556L38.333 31.9699C35.6711 32.5284 33.0603 30.8232 32.5018 28.1613L32.18 26.6276Z",
    fill: "#F1AD46"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.4533,
    cy: 15.3322,
    r: 4.47706,
    transform: "rotate(-11.8496 91.4533 15.3322)",
    fill: "#F5C47A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5275,
    cy: 25.934,
    r: 4.47706,
    transform: "rotate(-11.8496 84.5275 25.934)",
    fill: "#F9DDB3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.055,
    cy: 22.2567,
    r: 4.47706,
    transform: "rotate(-11.8496 102.055 22.2567)",
    fill: "#F1AD46"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1311,
    cy: 32.8588,
    r: 4.47706,
    transform: "rotate(-11.8496 95.1311 32.8588)",
    fill: "#F5C47A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameController);
export default __webpack_public_path__ + "static/media/game-controller.63f950633ebdb4489fcca8b5dcaa01b9.svg";
export { ForwardRef as ReactComponent };